
import {
  defineComponent,
  computed,
  ref,
  watch,
  SetupContext,
  WatchStopHandle,
  onMounted,
  getCurrentInstance,
  nextTick,
  onUnmounted,
} from 'vue';
import BScroll from 'better-scroll';

export default defineComponent({
  name: 'TRanger',
  components: {},
  props: {
    modelValue: {
      required: true,
      type: Number,
      default: 0,
      validator: (value: number) => value >= 0,
    },
    options: {
      required: true,
      type: Array,
      default: () => [{ key: 'Loading', value: 'Loading' }],
    },
  },
  emits: ['click', 'change', 'update:modelValue'],
  setup(props, context: SetupContext) {
    /** 组件的className前辍 */
    const prefixCls = ref('t-ranger');
    /** 获取组件上下文 */
    const instance = getCurrentInstance();
    const wheel = ref({} as any);
    // 序列化业务场景传入的options信息
    const getSerializeOptions = computed(() => {
      const output: any = [];
      if (props.options && props.options.length) {
        props.options.forEach(item => {
          if (typeof item === 'string' || typeof item === 'number') {
            output.push({
              value: item,
              disabled: false,
            });
          } else {
            output.push(item);
          }
        });
      }
      return output;
    });

    /** 模板依赖的className */
    const getClasses = computed(() => {
      return {
        wrap: prefixCls.value,
        scroll: [`${prefixCls.value}-scroll`],
        itemTitle: [`${prefixCls.value}-item-title`],
        maskTop: [`${prefixCls.value}-mask`, `${prefixCls.value}-mask__top`],
        maskBottom: [`${prefixCls.value}-mask`, `${prefixCls.value}-mask__bottom`],
      };
    });

    /** 对外响应的事件 */
    const listener = (event: any) => context.emit('click', event);
    const emitEvent = () => {
      context.emit('update:modelValue', wheel.value.getSelectedIndex());
      context.emit('change', wheel.value.getSelectedIndex());
    };
    /** 初始化滚轮 */
    const initWheel = (index: number) => {
      const wheelWrapper = (instance as any).refs.wheelWrapper as HTMLDivElement;
      const currentIndex = index === -1 ? 0 : index;
      const selectedIndex = index > getSerializeOptions.value.length - 1 ? 0 : currentIndex;
      const scrollParams = {
        wheel: {
          selectedIndex,
          wheelWrapperClass: `${prefixCls.value}-scroll`,
          wheelItemClass: `${prefixCls.value}-item`,
          wheelDisabledItemClass: `${prefixCls.value}-item__disabled`,
        },
        observeDOM: false,
      } as Partial<any>;
      return new BScroll(wheelWrapper, scrollParams);
    };
    /** 某一个选项是否禁用 */
    const isDiabled = (index: number) =>
      getSerializeOptions.value[index] && getSerializeOptions.value[index].disabled === true;
    /** 重新格式化列表依赖的className */
    const rangerItemClass = (index: number) => {
      const className = [`${prefixCls.value}-item`];
      if (isDiabled(index)) {
        className.push(`${prefixCls.value}-item__disabled`);
      }
      return className;
    };
    // 监听到modelValue变化时需要滚动到对应索引元素
    watch(
      () => props.modelValue,
      (newValue, oldValue) => {
        if (props.options && props.options.length) {
          nextTick(() => {
            wheel.value.wheelTo(newValue);
          });
        }
      },
    );
    // 监听到options变化时需要滚动到对应索引元素
    watch(
      () => props.options,
      (newOptions, oldOptions) => {
        if (newOptions && newOptions.length) {
          nextTick(() => {
            wheel.value.wheelTo(props.modelValue);
          });
        }
      },
    );



    const stopWatchOptions = watch(
      () => props.options,
      (newValue, oldValue) => nextTick(() => wheel.value.refresh()),
    );

    const stopWatchModelValue = watch(
      () => props.modelValue,
      (newValue, oldValue) => {
        if (props.options && props.options.length) {
          wheel.value.destroy();
          nextTick(() => {
            wheel.value = initWheel(newValue);
            wheel.value.on('scrollEnd', emitEvent);
          });
        }
      },
    );

    onMounted(() => {
      if (props.options && props.options.length) {
        wheel.value = initWheel(props.modelValue);
        wheel.value.on('scrollEnd', emitEvent);
      }
    });

    onUnmounted(() => {
      if (props.options && props.options.length) {
        wheel.value.destroy();
      }
      stopWatchOptions();
      stopWatchModelValue();
    });

    return {
      prefixCls,
      getClasses,
      wheel,
      getSerializeOptions,
      listener,
      rangerItemClass,
    };
  },
});
